import axios, { AxiosError } from "axios";
import QueryString from "qs";

export const client = axios.create({
  baseURL: `${process.env.REACT_APP_BASE_URL}`,
  paramsSerializer: param => QueryString.stringify(param),
  transformRequest: data => QueryString.stringify(data),
  withCredentials: true,
});

client.interceptors.response.use(
  response => response.data,
  (error: Error | AxiosError) => {
    if (!axios.isAxiosError(error)) {
      return null;
    }

    if (error.response?.status === 401) {
      window.location.replace('/sign-in');
      sessionStorage.clear();
    }

    return Promise.reject(error);
  }

)

